// Because we used module.hot, ESLint thinks we are trying to use module.exports
/* eslint-disable import/no-import-module-exports, import/max-dependencies */
import "../scss/global.scss";
import lottieInit from "./lottieInit";
import mobileFooterNavInit from "./mobileFooterNavInit";
import fadeInInit from "./fadeInInit";
import fancyboxInit from "./fancyboxInit";
import buttonScrollTo from "./buttonScrollTo";
import shareButtons from "./shareButtons";
import initTabs from "./initTabs";
import a11yMenu from "./a11yMenu";
import mobileNav from "./mobileNav";
import hsFormHandlers from "./hsFormHandlers";
import ajaxForm from "./ajaxForm";
import scrollCheck from "./scrollCheck";
import exposedPopup from "./exposedPopup";
import FormHubspot from "./formHubspot";
import AnnouncementBar from "./announcementBar";

const $ = jQuery.noConflict();

// eslint-disable-next-line max-statements
$(document).ready(function onReady() {
    mobileNav();
    mobileFooterNavInit();
    lottieInit();
    a11yMenu();
    fancyboxInit();
    buttonScrollTo();
    shareButtons();
    initTabs();
    hsFormHandlers();
    scrollCheck();
    ajaxForm();
    exposedPopup();

    const cFormHubspot = new FormHubspot();

    cFormHubspot.bootstrap();

    const ab = new AnnouncementBar();

    ab.bootstrap();
});

$(window).load(function onLoad() {
    fadeInInit();
});

// Parcel hot reload.
// eslint-disable-next-line unicorn/prefer-module, no-undef
if (module.hot) {
    // eslint-disable-next-line unicorn/prefer-module, no-undef
    module.hot.accept();
}
